import { render, staticRenderFns } from "./PackEditor.vue?vue&type=template&id=6f8dd073"
import script from "./PackEditor.vue?vue&type=script&lang=js"
export * from "./PackEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports